var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"input",staticClass:"ag-input-field-input ag-text-field-input",staticStyle:{"width":"100%","height":"35px","text-align":"right"},domProps:{"value":_vm.displayValue},on:{"input":_vm.onInput,"blur":_vm.onBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }